import AdminManagement from "./components/adminManagement"

export default AdminManagement
